import get from 'lodash/get';
import values from 'lodash/values';
import { createSelector } from 'reselect';
import { getAdminState } from '../selectors';

// eslint-disable-next-line import/prefer-default-export
export const getAppsState = createSelector(
  [getAdminState],
  adminState => get(adminState, 'apps'),
);

export const getApps = createSelector(
  [getAppsState],
  appsState => get(appsState, 'list'),
);

export const getAppList = createSelector(
  [getApps],
  (apps) => {
    if (!apps) return null;
    return values(apps);
  },
);

export const getApp = (state, { params }) => {
  const res = get(getApps(state), params.clientId);
  return res;
};

export const getLoading = createSelector(
  [getAppsState],
  appsState => !!get(appsState, 'loading'),
);

export const getCreating = createSelector(
  [getAppsState],
  appsState => !!get(appsState, 'creating'),
);

export const getUpdating = createSelector(
  [getAppsState],
  appsState => !!get(appsState, 'updating'),
);
